import type { ComponentType } from 'react';

type PageModule = { default: ComponentType };

/**
 * Seitendateien der Welle 2 (`routes/<ordner>/<name>.page.tsx`, Standardexport). Das Muster muss für Vite ein
 * Textliteral sein; jede Datei wird erst beim Aufruf ihrer Seite geladen. Tests ersetzen dieses Modul.
 */
const loaders = import.meta.glob<PageModule>('../routes/**/*.page.tsx');

/** Lader der Seitendatei (Pfad relativ zu `routes/`), oder `undefined`, wenn sie noch nicht existiert. */
export function pageLoader(file: string): (() => Promise<PageModule>) | undefined {
  return loaders[`../routes/${file}`];
}
